import React, { useCallback, useEffect, useState , useContext } from "react";
import { Modal, ModalBody, ModalContent, ModalOverlay , ModalHeader , ModalFooter  } from "@chakra-ui/modal";
import ReactFlow, {
  MiniMap,
  Controls,
  Background,
  useNodesState,
  useEdgesState,
  addEdge,
  Connection,
  Edge,
  Node,
  Position,
  ReactFlowProvider,
  Handle,
} from "reactflow";
import { MultiSelect } from "react-multi-select-component";
import "reactflow/dist/style.css";
import { useDisclosure } from "@chakra-ui/hooks";
import { MdAdd, MdCheck, MdDelete, MdFileCopy, MdHighlightOff } from "react-icons/md";
import Card from "../../../components/card/custom";
import { allCardType , allCurrency , allDays , allCountries } from '../../../utils/smartVariable';
import { TimePicker } from "antd";
import dayjs from "dayjs";
import { BsArrowLeft, BsFiletypeJson } from "react-icons/bs";
import { FiPlusSquare, FiSave } from "react-icons/fi";
import { createSmartRoutingNew, getSmartRouting , ClientGatewaysForSmartRouting } from "../../../api/smart-routing";
import { useParams } from "react-router-dom";
import toast from "react-hot-toast";
import { motion } from "framer-motion";
import { ClientContext } from "ClientProvider";
import { Link } from "react-router-dom";
import DivLoader from "components/divloader/DivLoader";

let id = 0;
const getId = () => `node_${id++}`;
interface Condition {
  key: string;
  operator: string;
  value: string | string[];
  hasError?: boolean;
  hasKeyError?: boolean;
  hasOperatorError?: boolean;
}

const conditionNode = ({ data }: any) => {
  const hasAnyError = data.conditions.some((condition: Condition) =>
    condition.hasError || condition.hasKeyError || condition.hasOperatorError
  );
  const MotionWrapper = hasAnyError ? motion.div : "div";
  return (
    <motion.div
      animate={
        hasAnyError
          ? { x: [0, -3, 3, -3, 3, 0] }
          : { x: 0 }
      }
      transition={hasAnyError ? { duration: 0.3 } : undefined}
    >
    <div className="relative w-[300px] rounded-2xl border border-purple-300 bg-purple-50 shadow-lg p-4 text-sm">
      <button
        className="absolute top-2 right-2 text-purple-500 hover:text-red-600"
        onClick={() => data.onRemove(data.id)}
      >
        <MdHighlightOff size={20} />
      </button>
      <div className="flex items-center gap-2 mb-3">
        <span className="text-purple-600 text-xl">🧠</span>
        <h3 className="text-purple-700 font-bold text-base tracking-wide">Condition</h3>
      </div>
      <div className="space-y-3">
        {data.conditions.map((condition: any, index: number) => {
          const allKeys = [ "amount","geo-location","card-type","currency","time","day","card-bin",];
          const usedKeys = data.conditions.filter((_ : any, i : any) => i !== index).map((c: any) => c.key);
          const availableKeys = allKeys.filter((k) => !usedKeys.includes(k) || k === condition.key);
          return (
            <div key={index} className="relative bg-white border border-purple-200 rounded-md p-3 shadow-sm space-y-2">
              <div className="grid grid-cols-2 gap-4">
                <div className="w-full">
                  <select
                    className="w-full border rounded px-2 py-1 text-xs"
                    value={condition.key}
                    onChange={(e) => {
                      data.onChange(data.id, "key", e.target.value, index);
                      data.onChange(data.id, "value", "", index);
                      data.onChange(data.id, "operator", "", index);
                      data.onChange(data.id, "hasKeyError", !e.target.value, index);
                      data.onChange(data.id, "hasOperatorError", true, index);

                    }}
                  >
                    <option value="">Select Condition</option>
                    {availableKeys.map((key) => (
                      <option key={key} value={key}>
                        {key.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())}
                      </option>
                    ))}
                  </select>
                  {condition.hasKeyError && <span className="text-red-500 text-xs">Required</span>}
                </div>
                <div className="w-full">
                  <select
                    className="w-full border rounded px-2 py-1 text-xs"
                    value={condition.operator}
                    onChange={(e) => {
                      data.onChange(data.id, "operator", e.target.value, index);
                      data.onChange(data.id, "value", "", index);
                      data.onChange(data.id, "hasOperatorError", !e.target.value, index);
                      data.onChange(data.id, "hasError", true, index);
                    }}
                  >
                    <option value="">Select Operator</option>
                    <option value="equal">Equals</option>
                    <option value="not_equal">Not Equals</option>
                    {condition.key === 'amount' || condition.key === 'time' ? (
                      <>
                        <option value="greater">Greater Than</option>
                        <option value="less">Less Than</option>
                        <option value="between">Range</option>
                      </>
                    ) : condition.key === 'geo-location' || condition.key === 'card-type' || condition.key === 'currency' || condition.key === 'day' ? (
                      <>
                        <option value="in">In</option>
                        <option value="not_in">Not In</option>
                      </> 
                    ) : null}
                  </select>
                  {condition.hasOperatorError && <span className="text-red-500 text-xs">Required</span>}
                </div>
              </div>
              {condition.key === 'amount' ? (
                condition.operator === 'between' ? (
                  <>
                    <div className="flex gap-2">
                      <div className="w-1/2 flex flex-col">
                        <input
                          type="text"
                          className="w-full border rounded px-2 py-1 text-xs"
                          placeholder="Min"
                          value={condition.value?.split(',')[0] || ""}
                          onChange={(e) => {
                            const min = e.target.value;
                            const max = condition.value?.split(',')[1] || "";
                            if (/^\d*\.?\d*$/.test(min)) {
                              data.onChange(data.id, "value", `${min},${max}`, index); 
                            }
                            if(condition.value?.split(',')[0] != "" && condition.value?.split(',')[1]!= "") {
                              data.onChange(data.id, "hasError", !min, index);
                            }
                          }}
                        />
                      </div>
                      <div className="w-1/2 flex flex-col">
                        <input
                          type="text"
                          className="w-full border rounded px-2 py-1 text-xs"
                          placeholder="Max"
                          value={condition.value?.split(',')[1] || ""}
                          onChange={(e) => {
                            const max = e.target.value;
                            const min = condition.value?.split(',')[0] || "";
                            if (/^\d*\.?\d*$/.test(max)) {
                              data.onChange(data.id, "value", `${min},${max}`, index);
                            }
                            if(condition.value?.split(',')[0] != "" && condition.value?.split(',')[1]!= "") {
                              data.onChange(data.id, "hasError", !max, index);
                            }
                          }}
                        />
                      </div>
                    </div>
                    {condition.hasError && <span className="text-red-500 text-xs">Required</span>}
                  </>
                ) : (
                  <>
                    <input
                      type="text"
                      className="w-full border rounded px-2 py-1 text-xs"
                      placeholder="Enter value"
                      value={condition.value}
                      onChange={(e) => {
                        const val = e.target.value;
                        if (/^\d*\.?\d*$/.test(val)) {
                          data.onChange(data.id, "value", val, index);
                          data.onChange(data.id, "hasError", !val, index);
                        }
                      }}
                    />
                    {condition.hasError && <span className="text-red-500 text-xs">Required</span>}
                  </>
                )
              ) : condition.key === 'card-bin' ? (
                <>
                  <input
                    type="text"
                    className="w-full border rounded px-2 py-1 text-xs"
                    placeholder="Enter value"
                    value={condition.value}
                    maxLength={6}
                    onChange={(e) => {
                      const val = e.target.value;
                      const isNumeric = /^\d*$/.test(val);
                      const isCardBin = condition.key === "card-bin";
                      if (isNumeric) {
                        let isValid = true;
                        if (isCardBin) {
                          isValid = val.length === 6;
                        } else {
                          isValid = val.length <= 6;
                        }
                        data.onChange(data.id, "value", val, index);
                        data.onChange(data.id, "hasError", !isValid, index);
                      }
                    }}
                  />
                  {condition.hasError && (
                    <span className="text-red-500 text-xs">
                      {condition.value === ""
                        ? "Required"
                        : condition.value.length !== 6
                        ? "Must be exactly 6 digits"
                        : "Required"}
                    </span>
                  )}

                </>
              ) : condition.key === 'currency' ? (
                condition.operator === 'in' || condition.operator === 'not_in' ? (
                  <>
                    <MultiSelect
                      options={allCurrency}
                      value={allCurrency.filter(opt => condition.value?.includes(opt.value))}
                      onChange={(selected: any) => {
                        const values = selected.map((s: any) => s.value);
                        data.onChange(data.id, "value", values, index);
                        data.onChange(data.id, "hasError", values.length === 0, index);
                      }}
                      labelledBy={"Select"}
                      overrideStrings={{ "noOptions": "Currency not found" }}
                      valueRenderer={(selected, options) => {
                        if (selected.length === 0) return "Select currency";
                        if (selected.length === options.length) return "All currency are selected";
                        return selected.map((option) => option.label).join(", ");
                      }}
                    />
                    {condition.hasError && <span className="text-red-500 text-xs">Required</span>}
                  </>
                ) : (
                  <>
                    <select
                      className="w-full border rounded px-2 py-1 text-xs"
                      value={condition.value}
                      onChange={(e) => {
                        data.onChange(data.id, "value", e.target.value, index);
                        data.onChange(data.id, "hasError", !e.target.value, index);
                      }}
                    >
                      <option value="">Select Currency</option>
                      {allCurrency.map((data: any) => (
                        <option key={data?.value} value={data?.value}>
                          {data?.label}
                        </option>
                      ))}
                    </select>
                    {condition.hasError && <span className="text-red-500 text-xs">Required</span>}
                  </>
                )
              ) : condition.key === 'card-type' ? (
                condition.operator === 'in' || condition.operator === 'not_in' ? (
                  <>
                    <MultiSelect
                      options={allCardType}
                      value={allCardType.filter(opt => condition.value?.includes(opt.value))}
                      onChange={(selected: any) => {
                        const values = selected.map((s: any) => s.value);
                        data.onChange(data.id, "value", values, index);
                        data.onChange(data.id, "hasError", values.length === 0, index);
                      }}
                      labelledBy={"Select"}
                      overrideStrings={{ "noOptions": "Card type not found" }}
                      valueRenderer={(selected, options) => {
                        if (selected.length === 0) return "Select card type";
                        if (selected.length === options.length) return "All card type are selected";
                        return selected.map((option) => option.label).join(", ");
                      }}
                    />
                    {condition.hasError && <span className="text-red-500 text-xs">Required</span>}
                  </>
                ) : (
                  <>
                    <select
                      className="w-full border rounded px-2 py-1 text-xs"
                      value={condition.value}
                      onChange={(e) => {
                        data.onChange(data.id, "value", e.target.value, index);
                        data.onChange(data.id, "hasError", !e.target.value, index);
                      }}
                    >
                      <option value="">Select Cardtype</option>
                      {allCardType.map((data: any) => (
                        <option key={data?.value} value={data?.value}>
                          {data?.label}
                        </option>
                      ))}
                    </select>
                    {condition.hasError && <span className="text-red-500 text-xs">Required</span>}
                  </>
                )
              ) : condition.key === 'day' ? (
                condition.operator === 'in' || condition.operator === 'not_in' ? (
                  <>
                    <MultiSelect
                      options={allDays}
                      value={allDays.filter(opt => condition.value?.includes(opt.value))}
                      onChange={(selected: any) => {
                        const values = selected.map((s: any) => s.value);
                        data.onChange(data.id, "value", values, index);
                        data.onChange(data.id, "hasError", values.length === 0, index);
                      }}
                      labelledBy={"Select"}
                      overrideStrings={{ "noOptions": "Days not found" }}
                      valueRenderer={(selected, options) => {
                        if (selected.length === 0) return "Select days";
                        if (selected.length === options.length) return "All days are selected";
                        return selected.map((option) => option.label).join(", ");
                      }}
                    />
                    {condition.hasError && <span className="text-red-500 text-xs">Required</span>}
                  </>
                ) : (
                  <>
                    <select
                      className="w-full border rounded px-2 py-1 text-xs"
                      value={condition.value}
                      onChange={(e) => {
                        data.onChange(data.id, "value", e.target.value, index);
                        data.onChange(data.id, "hasError", !e.target.value, index);
                      }}
                    >
                      <option value="">Select Day</option>
                      {allDays.map((data: any) => (
                        <option key={data?.value} value={data?.value}>
                          {data?.label}
                        </option>
                      ))}
                    </select>
                    {condition.hasError && <span className="text-red-500 text-xs">Required</span>}
                  </>
                )
              ) : condition.key === 'geo-location' ? (
                condition.operator === 'in' || condition.operator === 'not_in' ? (
                  <>
                    <MultiSelect
                      options={allCountries}
                      value={allCountries.filter(opt => condition.value?.includes(opt.value))}
                      onChange={(selected: any) => {
                        const values = selected.map((s: any) => s.value);
                        data.onChange(data.id, "value", values, index);
                        data.onChange(data.id, "hasError", values.length === 0, index);
                      }}
                      labelledBy={"Select"}
                      overrideStrings={{ "noOptions": "Country not found" }}
                      valueRenderer={(selected, options) => {
                        if (selected.length === 0) return "Select country";
                        if (selected.length === options.length) return "All countries are selected";
                        return selected.map((option) => option.label).join(", ");
                      }}
                    />
                    {condition.hasError && <span className="text-red-500 text-xs">Required</span>}
                  </>
                ) : (
                  <>
                    <select
                      className="w-full border rounded px-2 py-1 text-xs"
                      value={condition.value}
                      onChange={(e) => {
                        data.onChange(data.id, "value", e.target.value, index);
                        data.onChange(data.id, "hasError", !e.target.value, index);
                      }}
                    >
                      <option value="">Select Country</option>
                      {allCountries.map((data: any) => (
                        <option key={data?.value} value={data?.value}>
                          {data?.label}
                        </option>
                      ))}
                    </select>
                    {condition.hasError && <span className="text-red-500 text-xs">Required</span>}
                  </>
                )
              ) : condition.key === 'time' ? (
                condition.operator === 'between' ? (
                  <>
                    <div className="flex gap-2">
                      <div className="w-1/2 flex flex-col">
                        <TimePicker
                          format="HH:mm"
                          value={
                            condition.value?.split(',')[0]
                              ? dayjs(condition.value.split(',')[0], "HH:mm")
                              : null
                          }
                          onChange={(val) => {
                            const end = condition.value?.split(',')[1] || "";
                            const newStart = val ? dayjs(val).format("HH:mm") : "";
                            const newValue = `${newStart},${end}`;

                            data.onChange(data.id, "value", newValue, index);

                            const [s, e] = newValue.split(",");
                            data.onChange(data.id, "hasError", !(s && e), index);
                          }}
                          // onChange={(val) => {
                          //   const end = condition.value?.split(',')[1] || "";
                          //   data.onChange(data.id, "value", `${dayjs(val).format("HH:mm")},${end}`, index);
                          //   if(condition.value?.split(',')[0] != "" && condition.value?.split(',')[1] != "") {
                          //     data.onChange(data.id, "hasError", !val, index);
                          //   }
                          // }}
                          className="w-full"
                        />
                      </div>
                      <div className="w-1/2 flex flex-col">
                        <TimePicker
                          format="HH:mm"
                          disabled={!condition.value?.split(',')[0]}
                          disabledTime={() => {
                            const start = condition.value?.split(',')[0];
                            if (!start) return {};
                            const startTime = dayjs(start, "HH:mm");
                            return {
                              disabledHours: () =>
                                Array.from({ length: startTime.hour() }, (_, i) => i),

                              disabledMinutes: (selectedHour) =>
                                selectedHour === startTime.hour()
                                  ? Array.from(
                                      { length: startTime.minute() + 1 },
                                      (_, i) => i
                                    )
                                  : [],
                            };
                          }}
                          value={
                            condition.value?.split(',')[1]
                              ? dayjs(condition.value.split(',')[1], "HH:mm")
                              : null
                          }
                          onChange={(val) => {
                            const start = condition.value?.split(',')[0] || "";
                            const newEnd = val ? dayjs(val).format("HH:mm") : "";
                            const newValue = `${start},${newEnd}`;

                            data.onChange(data.id, "value", newValue, index);

                            const [s, e] = newValue.split(",");
                            data.onChange(data.id, "hasError", !(s && e), index);
                          }}
                          // onChange={(val) => {
                          //   const start = condition.value?.split(',')[0] || "";
                          //   data.onChange(data.id, "value", `${start},${dayjs(val).format("HH:mm")}`, index);
                          //   if(condition.value?.split(',')[0] != "" && condition.value?.split(',')[1] != "") {
                          //     data.onChange(data.id, "hasError", !val, index);
                          //   }
                          // }}
                          className="w-full"
                        />
                      </div>
                    </div>
                    {condition.hasError && <span className="text-red-500 text-xs">Required</span>}
                  </>
                ) : (
                  <>
                    <TimePicker
                      onChange={(val) => {
                        data.onChange(data.id, "value", dayjs(val).format("HH:mm"), index);
                        data.onChange(data.id, "hasError", !val, index);
                      }}
                      value={condition.value ? dayjs(condition.value, "HH:mm") : null}
                      format="HH:mm"
                      className="w-full"
                    />
                    {condition.hasError && <span className="text-red-500 text-xs">Required</span>}
                  </>
                )
              ) : null}
              {index > 0 && (
                <button
                  className="absolute top-[-15px] right-[-5px] text-purple-500 hover:text-red-600"
                  onClick={() => data.removeCondition(data.id, index)}
                >
                  <MdHighlightOff size={20} />
                </button>
              )}
            </div>
          )
        })}
        {data.conditions.length < 7 && (
        <button
          className="text-xs text-purple-600 hover:underline mt-2"
          onClick={() => data.addCondition(data.id)}
        >
          ➕ Add Condition
        </button>
        )}
      </div>
      <Handle type="source" position={Position.Right} className="custom-handle-condition"/>
    </div>
    </motion.div>
  )
};
const actionNode = ({ data }: any) => (
  <motion.div
    initial={{ scale: 0.9, opacity: 0 }}
    animate={{ scale: 1, opacity: 1 }}
    transition={{ duration: 0.3 }}
  >
  <div className="relative w-[240px] rounded-xl shadow-md border bg-green-50 p-4 text-sm space-y-3">
    <button
      className="absolute top-1 right-1 text-red-500 hover:text-red-700"
      onClick={() => data.onRemove(data.id)}
    >
      <MdHighlightOff size={18} />
    </button>
    <h3 className="font-semibold text-green-700">⚙️ Action</h3>
    <select
    className="w-full border rounded px-2 py-1 text-sm"
    value={data.action}
    onChange={(e) => data.onChange(data.id, "action", e.target.value)}
    >
    <option value="process_payment">Process Payment</option>
    </select>
    <select
      className="w-full border rounded px-2 py-1 text-sm"
      value={data.gateway}
      onChange={(e) => data.onChange(data.id, "gateway", e.target.value)}
    >
        {data?.gateways.map((gate: any) => (
          <option key={gate?.id} value={gate?.id}>
            {gate?.name}
          </option>
        ))}
    </select>
    <Handle type="target" position={Position.Left} className="custom-handle-action"/>
  </div>
  </motion.div>
);
const nodeTypes = {
  conditionNode,
  actionNode,
};

export default function FlowChart() {
  const [nodes, setNodes, onNodesChange] = useNodesState([]);
  const [edges, setEdges, onEdgesChange] = useEdgesState([]);
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [isCloseModal, setIsCloseModal] =  useState<boolean>(false);
  const [createdJson, setJSON] = useState("");
  const [copyJson, setCopyJson] = React.useState<boolean>(false)
  const [isLoading, setLoading] = useState<boolean>(false);
  const [isSubmitLoading, setSubmitLoading] = useState<boolean>(false);
  const prams = useParams();
  const [paymentGateway, setPaymentGateway] = useState<string>("");
  const [storeDropDownData, setStoreDropDownData] = useState([]);
  const { singleRoleData, setSingleRoleData } = useContext(ClientContext);
  const { id: clientId } = prams;

  const addCondition = (nodeId: string) => {
    const allKeys = [
      "amount",
      "geo-location",
      "card-type",
      "currency",
      "time",
      "day",
      "card-bin",
    ];

    setNodes((nds) =>
      nds.map((node) => {
        if (node.id !== nodeId) return node;

        const usedKeys = node.data.conditions.map((c: any) => c.key);
        const nextKey = allKeys.find((k) => !usedKeys.includes(k));
        if (!nextKey) return node;

        return {
          ...node,
          data: {
            ...node.data,
            conditions: [
              ...node.data.conditions,
              { key: "", operator: "", value: "" },
            ],
          },
        };
      })
    );
  };
  const removeCondition = (nodeId: string, index: number) => {
    setNodes((nds) =>
      nds.map((node) =>
        node.id === nodeId
          ? {
              ...node,
              data: {
                ...node.data,
                conditions: node.data.conditions.filter(
                  (_: any, i: number) => i !== index
                ),
              },
            }
          : node
      )
    );
  };
  const enhanceNodeData = (node: Node): Node => {
    if (node.type === "conditionNode") {
      return {
        ...node,
        data: {
          ...node.data,
          onChange: updateNodeData,
          onRemove: removeNode,
          addCondition,
          removeCondition,
        },
      };
    }
    if (node.type === "actionNode") {
      return {
        ...node,
        data: {
          ...node.data,
          onChange: updateNodeData,
          onRemove: removeNode,
        },
      };
    }
    return node;
  };
  useEffect(() => {
    fetchRoutingData();
  }, []);
  const fetchRoutingData = () => {
    getSmartRouting(clientId)
    .then((data: any) => {
      if(data?.route_nodes && data?.route_edges && data?.route_info) {
        const hydratedNodes = data.route_nodes.map(enhanceNodeData);
        setNodes(hydratedNodes)
        setEdges(data?.route_edges)
        setJSON(data?.route_info)
      }
    })
    .catch((err: any) => {})
    .finally(() => {
      setLoading(false);
    });
  }
  const handleClose = () => {
    setIsCloseModal(true);
    setTimeout(() => {
      setIsCloseModal(false);
      onClose();
    }, 300);
  };
  const updateNodeData = (id: string, field: string, value: any, index: number = 0) => {
    setNodes((nds) =>
      nds.map((node) =>
        node.id === id
          ? {
              ...node,
              data: {
                ...node.data,
                [field]: value,
                conditions: (node.data.conditions || []).map((condition: any, i: number) =>
                  i === index ? { ...condition, [field]: value } : condition
                ),
              },
            }
          : node
      )
    );
  };
  const addConditionNode = () => {
    // const newId = getId();
    const newId = crypto.randomUUID();
    const newNode: Node = {
      id: newId,
      type: "conditionNode",
      position: { x: Math.random() * 300, y: Math.random() * 300 },
      data: {
        id: newId,
        conditions: [
          { key: "", operator: "", value: "" },
        ],
        onChange: updateNodeData,
        onRemove: removeNode,
        addCondition: (id: string) => {
          const allKeys = [
            "amount",
            "geo-location",
            "card-type",
            "currency",
            "time",
            "day",
            "card-bin",
          ];
          setNodes((nds) => {
            const targetNode = nds.find((n) => n.id === id);
            if (!targetNode || !targetNode.data || !targetNode.data.conditions) return nds;
            const usedKeys = targetNode.data.conditions.map((c: any) => c.key);
            const nextKey = allKeys.find((k) => !usedKeys.includes(k)) || "";
            if (!nextKey) return nds;
            const newCondition = { key: "", operator: "", value: "" };
            return nds.map((node) =>
              node.id === id
                ? {
                    ...node,
                    data: {
                      ...node.data,
                      conditions: [...node.data.conditions, newCondition],
                    },
                  }
                : node
            );
          });
        },
        removeCondition: (id: string, index: number) => {
          setNodes((nds) =>
            nds.map((node) =>
              node.id === id
                ? { ...node, data: { ...node.data, conditions: node.data.conditions.filter((_condition: { field: string; operator: string; value: string }, i: number) => i !== index)
        } }
                : node
            )
          );
        },
      },
    };
    setNodes((nds) => [...nds, newNode]);
  };
  const addActionNode = () => {
    // const newId = getId();
    const newId = crypto.randomUUID();
    const newNode: Node = {
      id: newId,
      type: "actionNode",
      position: { x: Math.random() * 300 + 300, y: Math.random() * 300 },
      data: {
        id: newId,
        action: "process_payment",
        gateway: paymentGateway,
        gateways: storeDropDownData,
        onChange: updateNodeData,
        onRemove: removeNode,
      },
    };
    setNodes((nds) => [...nds, newNode]);
  };
  const onConnect = useCallback(
    (params: Edge | Connection) =>
      setEdges((eds) => addEdge({ ...params, animated: true, style: { stroke: "#2196f3" } }, eds)),
    []
  );
  const generateJSON = async (isSave = false) => {
    const isValid = validateConditions();
    if (!isValid) {
      toast.error("Please fill all required condition values");
      return;
    }
    const isValidActions = validateConditionsWithActions();
    if (!isValidActions) {
      toast.error("Each condition/action must be connected to exactly one action/condition. Some conditions/action are either not connected or connected to multiple actions/condition. Please update the connections to ensure each condition has one action/condition mapping.");
      return;
    }
    const groups: { [targetId: string]: string[] } = {};
    edges.forEach((edge: any) => {
      const { source, target } = edge;
      if (!groups[target]) groups[target] = [];
      groups[target].push(source);
    });
    const results: any[] = [];
    const processed = new Set();
    Object.entries(groups).forEach(([target, sources]) => {
      if (processed.has(target)) return;
      const targetNode = nodes.find((n) => n.id === target)?.data;
      const { action, gateway } = targetNode || {};
      const sourceNodes = sources
        .map((sourceId) => nodes.find((n) => n.id === sourceId))
        .filter(Boolean);
      const conditions = sourceNodes.flatMap((n) =>
        (n?.data?.conditions || []).map((cond: any) => {
          if (
            (cond.key === "amount" || cond.key === "time") &&
            cond.operator === "between" &&
            cond.value1 !== undefined &&
            cond.value2 !== undefined
          ) {
            return {
              ...cond,
              value: `${cond.value1},${cond.value2}`,
              value1: undefined,
              value2: undefined,
            };
          }

          delete cond.hasKeyError;
          delete cond.hasOperatorError;
          delete cond.hasError;
          return cond;
        })
      );
      results.push({
        action: {
          action,
          gateway,
        },
        condition: conditions,
      });
      processed.add(target);
    });
    setJSON(JSON.stringify(results, null, 2));
    if(!isSave) {
      onOpen();
    }

    return JSON.stringify(results, null, 2);
  };
  const removeNode = (id: string) => {
    setNodes((nds) => nds.filter((node) => node.id !== id));
    setEdges((eds) => eds.filter((edge) => edge.source !== id && edge.target !== id));
  };
  const validateConditions = () => {
    let hasErrors = false;
    let hasKeyErrors = false;
    let hasOperatorErrors = false;
    const updatedNodes = nodes.map((node) => {
      if (node.type === "conditionNode") {
        const updatedConditions = node.data.conditions.map((condition: Condition) => {
          let isEmpty = false;
          let isEmptyKey = false;
          let isEmptyOperator = false;

          if(condition.key == "") {
            isEmptyKey = true;
          } 

          if(condition.operator == "") {
            isEmptyOperator = true;
          }
          if (condition.operator === 'between' && (condition.key === 'amount' || condition.key === 'time')) {
            if (typeof condition.value === 'string') {
              const [min, max] = condition.value.split(',');
              isEmpty = !min || !max;
            } else {
              isEmpty = true;
            }
          } else if (condition.operator === 'in' || condition.operator === 'not_in') {
            isEmpty = !condition.value || (Array.isArray(condition.value) && condition.value.length === 0);
          } else if (condition.key === 'card-bin') {
            const val = String(condition.value || "");
            isEmpty = val === "" || val.length !== 6 || !/^\d{6}$/.test(val);
          } else {
            isEmpty = !condition.value;
          }
          if (isEmpty) hasErrors = true;
          if (isEmptyKey) hasKeyErrors = true;
          if (isEmptyOperator) hasOperatorErrors = true;
          return { ...condition, hasError: isEmpty , hasKeyError : isEmptyKey , hasOperatorError : isEmptyOperator };
        });
        return {
          ...node,
          data: {
            ...node.data,
            conditions: updatedConditions,
          },
        };
      }
      return node;
    });
    setNodes(updatedNodes);
    return !hasErrors && !hasKeyErrors && !hasOperatorErrors;
  };
  const validateConditionsWithActions = () => {
    let hasErrors = false;

    const conditionNodes = nodes.filter(n => n.type === "conditionNode");
    const actionNodes = nodes.filter(n => n.type === "actionNode");

    conditionNodes.forEach((conditionNode) => {
      const connectedActionEdges = edges.filter(
        (edge) =>
          edge.source === conditionNode.id &&
          actionNodes.some((a) => a.id === edge.target)
      );

      if (connectedActionEdges.length !== 1) {
        hasErrors = true;
      }
    });

    actionNodes.forEach((actionNode) => {
      const incomingConditionEdges = edges.filter(
        (edge) =>
          edge.target === actionNode.id &&
          conditionNodes.some((c) => c.id === edge.source)
      );

      if (incomingConditionEdges.length === 0) {
        hasErrors = true;
      }
    });

    // nodes.map((node) => {
    //   if (node.type === "conditionNode") {
    //     const connectedActionEdges = edges.filter(
    //       (edge) =>
    //         edge.source === node.id &&
    //         nodes.find((n) => n.id === edge.target && n.type === "actionNode")
    //     );
    //     if (connectedActionEdges.length !== 1) {
    //       hasErrors = true;
    //     }
    //   }
    // });

    return !hasErrors;
  };
  const saveChanges = async() => {
    setSubmitLoading(true)
    const generated = await generateJSON(true);
    const isValid = validateConditions();
    const isValidActions = validateConditionsWithActions();
    if (isValid && isValidActions) {
      if(generated && JSON.parse(generated).length > 0) {
        const data = {
          route_info: JSON.parse(generated),
          route_nodes : nodes,
          route_edges : edges
        }
        const updateData = await createSmartRoutingNew(data,clientId);
        const result = updateData.data
        if (result) {
          setSubmitLoading(false)
          toast.success("Smart routing data saved successfully");
        } else {
          setSubmitLoading(false)
          toast.error("Error while saving the smart routing data!!");
        }
      } else {
        setSubmitLoading(false)
        toast.error("Invalid smart routing configuration !!");
      }
    } else {
      setSubmitLoading(false)
    }
   
  }
  useEffect(() => {
    ClientGatewaysForSmartRouting(clientId)
      .then((data) => {
        const transformedData = data.map((gateway : any) => ({
          id: gateway.id,
          name: (singleRoleData[0]?.client?.value?.client_show_method_name) ? gateway.name : gateway.id,
        }));
        setStoreDropDownData(transformedData);
        if (transformedData[0]) {
          setPaymentGateway(transformedData[0].id);
        }
      })
      .catch((err) => {});
  }, []);
  return (
    <>
      <Card extra={"w-full h-full sm:overflow-auto px-6"}>
        <div className="relative mt-4 overflow-x-auto overflow-x-auto scrollbar scrollbar-track-gray-100 scrollbar-thumb-gray-300 scrollbar-track-rounded-full scrollbar-thumb-rounded-xl scrollbar-h-1.5 sm:rounded-lg ">
          <div className="flex  justify-between gap-3">
            <div className="flex gap-2">
              <button onClick={addConditionNode} className="flex items-center rounded-xl border border-blue-300 bg-blue-50 px-5 py-2 text-blue-500 outline-none">
                <FiPlusSquare size={20} /> <span className="ml-2">Add Condition</span>
              </button>
              <button onClick={addActionNode} className="flex items-center ml-2 rounded-xl border border-blue-300 bg-blue-50 px-5 py-2 text-blue-500 outline-none">
                <FiPlusSquare size={20} /> <span className="ml-2">Add Action</span>
              </button>
            </div>
            <div className="flex gap-2">
              <Link className="inline-flex" to={`/admin/clients`}>
                <button className="flex items-center gap-2 w-fit rounded-lg border px-4 py-2 outline-none border-red-300 bg-indigo-50 text-red-500">
                  <BsArrowLeft size={14} /> 
                  Back to client
                </button>
              </Link>
              <button onClick={() => generateJSON(false)} className="flex items-center ml-2 rounded-xl border border-blue-300 bg-blue-50 px-5 py-2 text-blue-500 outline-none">
                <BsFiletypeJson size={20} /> <span className="ml-2">Generate JSON</span>
              </button>
              <button onClick={saveChanges} className="flex items-center ml-2 rounded-xl border border-teal-300 bg-teal-50 px-5 py-2 text-teal-500 outline-none">
                {isSubmitLoading ? (
                  <DivLoader className="h-6 w-6 border-teal-300" />
                ):(
                  <>
                    <FiSave size={20} /> <span className="ml-2">Save Changes</span>
                  </>
                )}
              </button>
              </div>
          </div>
          <div className="h-[90vh] my-4 w-full border-2 border-gray-300 rounded-lg">
            <ReactFlow
              nodes={nodes}
              edges={edges}
              onNodesChange={onNodesChange}
              onEdgesChange={onEdgesChange}
              onConnect={onConnect}
              nodeTypes={nodeTypes}
              fitView
            >
              <MiniMap />
              <Controls />
              <Background />
            </ReactFlow>
          </div>
          <Modal isOpen={isOpen} onClose={() => {}}>
            <ModalOverlay className="bg-[#000] !opacity-30" />
              <Card extra={`fixed top-0 right-0 h-full rounded-none max-w-[600px] sm:w-full flex flex-col justify-start !z-[1004] overflow-y-auto scrollbar-hide overflow-auto ${
              isOpen && !isCloseModal ? "card-enter" : "card-exit"
              }`}>
                <ModalHeader className=" flex py-[20px] mb-[20px] px-[30px] text-2xl font-bold bg-brand-500 text-white">
                        <MdHighlightOff
                        className="absolute right-7 top-6 h-8 w-8 cursor-pointer text-white"
                        onClick={handleClose}
                        />
                        JSON View
                </ModalHeader>     
                <ModalBody className="p-4">
                  <div className="flex relative flex-col  overflow-auto mx-[35px] rounded-xl border border-gray-100  scrollbar scrollbar-h-1.5 scrollbar-track-gray-100 scrollbar-thumb-gray-300 scrollbar-track-rounded-full scrollbar-thumb-rounded-xl scrollbar-w-1.5">
                    <pre className="p-2">{createdJson}</pre>
                    <div className="absolute top-3 right-3 outline-none">
                      {copyJson ?
                        <MdCheck className="cursor-pointer text-teal-500 mr-4" />
                        :
                        <MdFileCopy
                          className="cursor-pointer text-teal-500 mr-4"
                          onClick={() => {
                                  navigator.clipboard.writeText(createdJson)
                                  setCopyJson(true);
                                  setTimeout(() => { setCopyJson(false) }, 1500)
                          }}
                        />
                      }
                    </div>
                  </div>
                </ModalBody>   
                <ModalFooter className="mt-[10px] p-4">
                  <div className="mt-5 flex gap-2">
                    <button
                      onClick={handleClose}
                      className="linear rounded-xl bg-gray-100 px-5 py-2 text-base font-medium text-navy-700 outline-none transition duration-200 hover:bg-gray-200 active:bg-gray-300 dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/30"
                    >
                      Close
                    </button>
                  </div>
                </ModalFooter>
              </Card>
          </Modal>
        </div>
      </Card>
    </>
  );
}
